// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_3YwSN"};